export default __webpack_public_path__ + "static/media/Achievements (3).2e71f183.jpg";